<div class="users-container">
<div class="query-strip-container mat-elevation-z2">
	<table height="100%" width="100%">
		<TR>
			<TD class="table-title-cell">
				<i class="fa fa-address-card fa-fw table-icon-header"
				style="width: 2em"></i>{{formTitle}}
			</TD>
			<TD align="center">
				<input text id="txtFilter" #txtFilter
                       matTooltip="Type to match data in all columns except date fields"
					class="qs_filter-field" [disabled]="this.isEditing"
					(keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
				<button mat-button matSuffix mat-icon-button
					matTooltip="Clear the filter" aria-label="Clear"
					(click)="txtFilter.value=''; clearFilter();">
					<mat-icon>close</mat-icon>
				</button></TD>
			<TD class="qs-label-cell" style="width: 60px; text-align: center;">Status:</TD>
			<TD class="qs-title-cell" style="width: 150px">
				<mat-select [disabled]="this.isEditing"
					disableOptionCentering
					[(value)]="selectedFilterStatus" #cbStatus floatLabel="never"
					class="dw-mat-select"
					style="width: 150px;"
					panelClass="local-drop-down-panel"
					(selectionChange)="onChangeStatusFilterValue()">
					<mat-option	value=2>All</mat-option>
					<mat-option value=1>Active</mat-option>
					<mat-option	value=0>InActive</mat-option>
				</mat-select>
			</TD>
			<TD class="table-pagination-cell" align="right">{{pagination}} Record(s) ...</TD>
		</TR>
	</table>
</div>

<div [ngClass]="contentClassName" class="table-container mat-elevation-z2"
	(keydown)="tableKeyDown($event)" tabindex="-1">
	<table mat-table [dataSource]="dataSource" id="userTableId"
		(matSortChange)="onSortChange($event)" matSort>

		<!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on
          the row definition" -->

		<!-- Id Column -->
		<ng-container matColumnDef="id">
		<th mat-header-cell class="mat-table-header-style" *matHeaderCellDef  mat-sort-header>Id</th>
		<td mat-cell class="mat-table-row-style-override" style="width:5% !important;"
			*matCellDef="let element;let tableRowIdx = index;">
			{{element.id}}</td>
		</ng-container>

		<!--element_name Column -->
		<ng-container matColumnDef="username" >
		<th mat-header-cell class="mat-table-header-style" *matHeaderCellDef mat-sort-header>User Name</th>
		<td mat-cell class="mat-table-row-style-override"  style="width:12% !important;"
			*matCellDef="let element">{{element.username}}</td>
		</ng-container>

		<!-- Full Name Column -->
		<ng-container matColumnDef="name">
		<th mat-header-cell class="mat-table-header-style" *matHeaderCellDef mat-sort-header>Full Name</th>
		<td mat-cell class="mat-table-row-style-override"  style="width: 15%;"
			*matCellDef="let element">{{element.name}}</td>
		</ng-container>

		<!-- Email Column -->

		<ng-container matColumnDef="email">
			<th mat-header-cell  class="mat-table-header-style" *matHeaderCellDef mat-sort-header>Email Address</th>
			<td mat-cell class="mat-table-row-style-override"  style="width: 20%;"
				*matCellDef="let element">{{element.email}}</td>
		</ng-container>

		<!-- Active state Column -->
		<ng-container matColumnDef="status">
			<th mat-header-cell class="mat-table-header-style"  *matHeaderCellDef
                mat-sort-header>Status</th>

			<!-- <td mat-cell *matCellDef="let element">{{element.displayStatus}}</td> -->
			<td mat-cell *matCellDef="let element"
                class="mat-table-row-style-override" style="width:100px!important;"
                (focus)="statusCellReceivedFocus(element.id)">

				<mat-select *ngIf="selectedRecord?.id == element.id"
							disableOptionCentering
							[(value)]="element.displayStatus"
                            #cbStatus floatLabel="never"
							class="dw-mat-select"
							panelClass="local-drop-down-panel"
							style="width:95px!important;"
							(selectionChange)="onStatusChange()" [disabled]="!visibleModify" >
					<mat-option	value="Active">Active</mat-option>
					<mat-option	value="InActive">InActive</mat-option>
				</mat-select>

				<span *ngIf="selectedRecord?.id !== element.id"
					  style="padding-left: 3px;">{{element.displayStatus}}</span>
			</td>
		</ng-container>
		<ng-container matColumnDef="invitationCount">
			<th mat-header-cell class="mat-table-header-style"  *matHeaderCellDef mat-sort-header>Invitation Status</th>
			<td mat-cell class="mat-table-row-style-override"  style="width: 12%;"
				*matCellDef="let element">{{invitationStatusLabeler(element)}}</td>
		</ng-container>
		<ng-container matColumnDef="securityGroupsList">
			<th mat-header-cell class="mat-table-header-style"  *matHeaderCellDef mat-sort-header>Security Groups</th>
			<td mat-cell class="mat-table-row-style-override"  style="width: 12%;"
				*matCellDef="let element">{{element.securityGroupsList}}</td>
		</ng-container>
		<ng-container matColumnDef="securityOverride">
			<th mat-header-cell class="mat-table-header-style"  *matHeaderCellDef mat-sort-header>Security Override</th>
			<td mat-cell class="mat-table-row-style-override"  style="width: 12%;"
				*matCellDef="let element"> <mat-icon class="override-icon" *ngIf="element.securityOverride && element.securityOverride.length > 0"
				 matTooltip="{{element.securityOverride}}">key</mat-icon>
			</td>
		</ng-container>
		<ng-container matColumnDef="lastLogin">
			<th mat-header-cell class="mat-table-header-style"  *matHeaderCellDef mat-sort-header>Last Login</th>
			<td mat-cell  class="mat-table-row-style-override" style="width: 15%;"
				*matCellDef="let element">{{lastLoginLabeler(element)}}</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row
			*matRowDef="let row; columns: displayedColumns;
				let tableRowIdx = index;"
			[ngClass]="{'row-selected': tableRowIdx == Idx}"
			(click)="onRowClicked(row)"
            (dblclick)="launchSecurityDialog()">

		</tr>
	</table>
</div>

<!-- Control strip -->
<div class="mat-elevation-z2 control-strip">
	<button *ngIf="visibleAdd" mat-button [disabled]="this.isEditing"
		class="command-button" matTooltip="Add a new record"
		(click)="addModifyRecord(true)" mat-button>
		<mat-icon>add_circle_outline</mat-icon>
		Add New
	</button>
	<button *ngIf="visibleModify" mat-button class="command-button"
		style="margin-top: 5px;" [disabled]="(Idx < 0|| this.isEditing)"
		matTooltip="Edit a selected record" (click)="addModifyRecord(false)"
		mat-button>
		<mat-icon>edit</mat-icon>
        Edit
	</button>
	<button *ngIf="visibleDelete" mat-button class="command-button"
		style="margin-top: 5px;" [disabled]="(Idx < 0 || this.isEditing)"
		matTooltip="Remove a selected record" (click)="removeRecord()"
		mat-button>
		<mat-icon>remove_circle_outline</mat-icon>
		Remove
	</button>
    <button *ngIf="visibleSecurity" mat-button class="command-button"
            style="margin-top: 5px;"
            [disabled]="(Idx < 0 || this.isEditing || enableSecurity === false)"
            matTooltip="Configure Security for the selected record"
            (click)="launchSecurityDialog()" mat-button>
        <mat-icon>key</mat-icon>
        Security
    </button>
	<button mat-button class="command-button" *ngIf="visibleInvite"
		style="margin-top: 5px; float: right; margin-right: 10px;" [disabled]="(this.isEditing)"
		matTooltip="Send invitation to users" (click)="openInvitationDialog()"
		mat-button>
		<mat-icon>outgoing_mail</mat-icon>
		Invite
	</button>
</div>

<!-- Detail container -->
<div class="usermgmt-container">
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="doTabChange($event)"
                               [(selectedIndex)]=selectedTabIndex>
                    <mat-tab label="Details" [disabled]="isEditing">
                        <div class="sub-tab-container-class detail-tab-additional">
	<div class="dwform" style="padding-right: 15px;"
		[formGroup]="formContent">

		<div class="dwform-cell" style="min-width: 480px;">

			<div class="dwform-row-double-gap"></div>

			<div class="dwform-row">
				<label class="label-field">Record ID:</label> <span
					class="form-required"> </span>
					<input class="input-field-short" placeholder="<id>"
					formControlName="id" type="text">
			</div>

			<div class="dwform-row-gap"></div>

			<div class="dwform-row">
				<label class="label-field">User Name:</label> <span
					class="form-required">*</span>
					<input class="input-field" #username id="username"
						   pattern="^(\d|\w)+$"
						   placeholder="<User Name>"
					formControlName="username" type="text" style="text-transform: lowercase;">
			</div>

			<div class="dwform-row-gap"></div>

			<div class="dwform-row">
				<label class="label-field">Full Name:</label> <span
					class="form-required">*</span>
				<input class="input-field" #fullname id="fullname"
					style="text-transform: capitalize"
					formControlName="name"
					placeholder="<Full Name>"
					type="text"	>
			</div>

			<div class="dwform-row-gap"></div>

			<div class="dwform-row">
				<label class="label-field">Active Status:</label> <span
					class="form-required">*</span>

				<mat-select
						#cbDetailStatus
						placeholder="- Please Select -"
						 disableOptionCentering
		                floatLabel="never"
						class="dw-mat-select"
						panelClass="local-drop-down-panel"
		                formControlName="status"
						style="width: 150px;font-size: 10pt;"
						[style.backgroundColor]="disabledFlag?'whitesmoke':'white'">
					<mat-option value="Active">Active</mat-option>
					<mat-option value="InActive">InActive</mat-option>
				</mat-select>
			</div>
			<div class="dwform-row-gap"></div>

			<div class="dwform-row">
				<label class="label-field">Email:</label> <span
					class="form-required">*</span>
				<input class="input-field" #email
				placeholder="<Email Address>"
					formControlName="email" type="text">
			</div>
			<div class="dwform-row-gap"></div>


			<div class="dwform-row">
			<label class="label-field">Agency:</label>
			<span class="form-required">*</span>

				<input class="input-field" disabled [value]="agencyName"
					  style="border: none; width: 230px; font-weight: bold"
					  placeholder="<Not set>"
					  type="text">

				<button mat-button class="command-button mat-mdc-raised-button" *ngIf="isEditing && agencyActive"
						style="scale: 90%; width: 60px;"
						matTooltip="Associate with an Agency" (click)="showAgencyDlg()"
						mat-button>
					Set
				</button>
			</div>
		</div>

		<!-- this is first select option list -->
		<div class="dwform-cell " style="min-width: 520px;">
			<label class="label-field-free" >Security Group List:</label>

			<mat-selection-list
					[(ngModel)]="assignedSecurityGroupsList"
					(selectionChange)="groupSelectionChanged()"
					[ngModelOptions]="{standalone: true}"
					style="width:500px; height: 230px; outline:none;"
					[disabled]="disabledFlag || !groupsActive">
				<mat-list-option
					*ngFor="let securityGroup of availableSecurityGroupsList"
					[value]="securityGroup.name">
					<div class="icon-list-local">
						<div style="width: 430px;">

                            <span *ngIf="securityGroup.activeStatus === 'Active'">
                                {{securityGroup.name}}
                            </span>
                            <span *ngIf="securityGroup.activeStatus === 'InActive'"
                                style="color: silver;">
                                {{securityGroup.name}} - <span style="font-style: italic;"> (InActive)
                            </span>
                            </span>
                        </div>
						<mat-icon style="color: darkblue; text-align:right;"
								  (mouseover)="doFunctionMouseOver(securityGroup.name)"
								  matTooltip="{{securityGroupToolTipText}}"
								  matTooltipPosition="left">info
						</mat-icon>
					</div>
				</mat-list-option>
			</mat-selection-list>
		</div>
	</div>
	  <div [hidden]='!strErr.length' style="left:10px;" class="error-line">{{strErr}}</div>

    <div class="save-close-strip" style="bottom:5px;">

        <button mat-button class="command-button"
                *ngIf="this.isEditing"
                (click)="submitRecord()" matTooltip="Submit the selected record" mat-button>
            <mat-icon>check_circle_outline</mat-icon>Submit</button>
        <button mat-button class="command-button"
                *ngIf="this.isEditing"
                (click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
            <mat-icon>highlight_off</mat-icon>Cancel</button>
        <button mat-button class="command-button"
                *ngIf="!this.isEditing && this._agencyView"
                (click)="closeAgencyViewDialog()" matTooltip="Cancel edit" mat-button>
            <mat-icon>highlight_off</mat-icon>Close</button>
    </div>
	 </div>
	 
                    </mat-tab>
                    <mat-tab label="History" [disabled]="isEditing">
                        <div class="sub-tab-container-class detail-tab-additional">
                            <transaction-history #history></transaction-history>
                        </div>
                    </mat-tab>
                </mat-tab-group>
</div>
  
</div>


<p-dialog header="Invite Users" [focusOnShow]="false"
		  [(visible)]="displayInvitationDlg" [modal]="true"
		  [style]="{width: '850px', height: '500px'}"
		  appendTo="body"
		  [minY]="35" [resizable]="false" [closable]="true" (onShow)="send_invite.setFocusOnSearch()">
	<app-send-invite #send_invite (cancelClicked)="cancelClickedFromSendInvite()"
					 (intitationsSent)="invitationSentHandler()"></app-send-invite>
</p-dialog>

<p-dialog header="Select an Agency"
          [(visible)]="displayAgencyDlg"
          [modal]="true"
		  appendTo="body"
		  [style]="{width: '500px', height: '490px'}"
		  [resizable]="false" [closable]="true" >
	<app-agencytable #agencyTableDlg [agencyList]="agencyList"
			(agencySelectedHandler)="agencySelectedHandler($event)"
            (agencyCancelHandler)="displayAgencyDlg=false">
	</app-agencytable>
</p-dialog>

<p-dialog header="User Security for '{{ selectedRecord?.name}}'"
          [appendTo]="'body'"
          [(visible)]="displaySecurityDialog"
          [modal]="true"
          [style]="{position: 'absolute',  minWidth: '805px', minHeight: '780px', width: '805px', height:'780px'}"
          [minY]="75" [closable]="true"
          [resizable]="false" >
    <app-security #dlgSecurity
                  [CalledFrom]="'userMgmt'"
                  [ParentId]=selectedRecord?.id
                  (submitButton)="doSecuritySubmit($event)"
                  (cancelButton)="displaySecurityDialog=false">
    </app-security>
</p-dialog>
